import { Injectable } from '@angular/core'
import { MatDialog, MatDialogConfig } from '@angular/material/dialog'
import { ConnectGmailDialogComponent } from './connect-gmail-dialog.component'

@Injectable()
export class ConnectGmailDialogService {
  constructor(private dialog: MatDialog) {}

  public open() {
    const defaultConfig: MatDialogConfig = {
      width: '650px',
      height: 'auto',
      panelClass: ['fixed-modal', 'no-scroll-modal'],
    }

    return this.dialog.open(ConnectGmailDialogComponent, defaultConfig)
  }
}
